<template>
  <div id="task_template">
    <el-divider content-position="center" v-if="!packageDisabled" style="margin-top: 0px;">
      <el-button type="text" icon="el-icon-add" @click="addPanelConfig">添加可选套餐</el-button>
    </el-divider>

    <Card v-for="(panelItem,index) in packagePanelConfigs" v-if="packagePanelConfigs&&packagePanelConfigs.length>0">
      <Row style="max-height:40px">
        <Col span="23">
          <Search :model="packagePanelConfigs[index].search" :label-position="'left'"
                  :elem="packagePanelConfigs[index].searchElem" :submit="false"
                  @on-changeend="(val,propName)=>{changePackages(val,propName,index)}"/>
        </Col>
        <Col span="1" v-if="!packageDisabled">
          <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="removeCollapse(index)"/>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <EditTabPanel ref="editTabPanel" :show-tabs="['physicalProject', 'lisProject']"
                        :model="'table'" :key="`edp${index}`" :maxHeight="'430px'"
                        :packagesId.sync="panelItem.search.packagesId"
                        :taskProjects.sync="panelItem.taskProjects"
                        :taskLisProjects.sync="panelItem.taskLisProjects"
                        :projectIds.sync="panelItem.projectIds"
                        :lisProjectIds.sync="panelItem.lisProjectIds"
                        :localApplicableAgeList="applicableAgeList"
                        :disabled="!(!itemDisabled&&packagePanelConfigs[index].search.packagesId)"
                        @setTaskProjects="setTaskProject"/>
        </Col>
      </Row>
    </Card>

  </div>
</template>
<script>
import EditTabPanel from "@/views/preScreening/task/EditTabPanel.vue"
import {_packagesList} from "@/services/screeningConfig/phlysicalPackage"

export default {
  name: "TaskTemplate",
  components: {EditTabPanel},
  data() {
    return {
      data: [],
      packagePanelConfigs: [],
      taskProjectList: []
    };
  },
  props: {
    packageDisabled: {
      type: Boolean,
      default: true
    },
    itemDisabled: {
      type: Boolean,
      default: true
    },
    packagesNames: {
      type: Array,
      default: () => {
        return [];
      }
    },
    applicableAgeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskProject: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    packagesNames: {
      handler(newVal, oldVal) {
        this.$props.packagesNames = newVal;
      }
    },
    taskProject: {
      handler(newVal, oldVal) {
        this.packagePanelConfigs = [];
        if (newVal && newVal.length > 0) {
          for (let i = 0; i < newVal.length; i++) {
            let item = newVal[i];
            let projectIds = [];
            if (item.taskProjects) {
              item.taskProjects.forEach(project => {
                if (project.status === 2 && project.projectId) {
                  projectIds.push(project.projectId)
                }
              });
            }

            let lisProjectIds = [];
            if (item.taskLisProjects) {
              item.taskLisProjects.forEach(lisProject => {
                if (lisProject.status === 2 && lisProject.lisProjectId) {
                  lisProjectIds.push(lisProject.lisProjectId)
                }
              });
            }

            this.packagePanelConfigs.push({
              taskProjects: item.taskProjects,
              taskLisProjects: item.taskLisProjects,
              projectIds: projectIds,
              lisProjectIds: lisProjectIds,
            })
            this.setSearchEle(i, item.packagesId)
          }
        } else {
          this.packagePanelConfigs = [];
        }
      }
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    setSearchEle(index, val) {
      this.packagePanelConfigs[index].search = {packagesId: val ? val : ''}
      this.packagePanelConfigs[index].searchElem = [
        {
          label: '体检套餐:',
          prop: "packagesId",
          placeholder: '请选择体检套餐',
          labelWidth: 75,
          element: 'select',
          option: this.$props.packagesNames,
          events: 'changeend',
          elemWidth: 'width:300px',
          disabled: this.packageDisabled,
        },
      ]
    },
    //增加配置
    addPanelConfig() {
      this.packagePanelConfigs.push({
        packagesId: "",
        taskProjects: [],
        taskLisProjects: [],
        projectIds: [],
        lisProjectIds: [],
      })
      this.setSearchEle(this.packagePanelConfigs.length - 1, '');
    },
    removeCollapse(index) {
      this.packagePanelConfigs.splice(index, 1);
    },
    changePackages(val, propName, index) {
      if (!val) {
        return;
      }
      _packagesList({packagesId: val}).then(res => {
        if (res.errcode === 1) {
          this.$emit("setPackageId", val)
          this.packagePanelConfigs[index].packagesId = res.data.packagesId.toString();
          this.packagePanelConfigs[index].packagesName = res.data.packagesName
          this.packagePanelConfigs[index].projectIds = res.data.projectIds
          this.packagePanelConfigs[index].lisProjectIds = res.data.lisProjectIds
        }
      })
    },
    setTaskProject(packageId, paramName, listData) {
      for (let i = 0; i < this.packagePanelConfigs.length; i++) {
        if ((this.packagePanelConfigs[i].search.packagesId + '') === (packageId + '')){
          this.packagePanelConfigs[i][paramName] = listData
        }
      }
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-divider--horizontal {display: block;height: 1px;width: 100%;margin: 24px 0;margin-top: 12px;}
</style>
